import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';

const GeneralRoute = ({ component: Component, ...restProps }) => (
  <Route {...restProps} render={(props) => <Component {...props} />} />
);

GeneralRoute.propTypes = {
  component: PropTypes.func.isRequired,
};

export default GeneralRoute;
